// assets/eme-sort-close.js
(() => {
  function closeAll(exceptEl) {
    document.querySelectorAll('details.eme-sort[open]').forEach((d) => {
      if (exceptEl && d === exceptEl) return;
      d.removeAttribute('open');
    });
  }

  document.addEventListener('click', (e) => {
    const clickedInside = e.target.closest('details.eme-sort');
    if (!clickedInside) {
      closeAll();
      return;
    }

    if (e.target.closest('.eme-sort-menu a')) {
      closeAll(clickedInside);
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeAll();
  });
})();